var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"back-button",attrs:{"id":"go-back","name":"go-back","vertical":"middle"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"material-icons"},[_vm._v("keyboard_backspace")]),_c('p',[_vm._v("Voltar")])])}
var staticRenderFns = []

export { render, staticRenderFns }